module.exports = {
      id: "depositMoney-usage",
      viewBox: "0 0 80 81",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#depositMoney",
      toString: function () {
        return this.url;
      }
    }